/* Option B: casual-copy deterrence on theme merchandising images, never DRM. */
(function () {
  if (window.Shopify?.designMode || window.EZOKOImageProtectionLoaded) return;
  window.EZOKOImageProtectionLoaded = true;

  // Match actual images, not the surrounding links, buttons or carousel surfaces.
  const images = [
    '.product__media-image-wrapper img', '.product__thumbnail img',
    'img.product-item__primary-image', 'img.product-item__secondary-image',
    'img.pv-color-card__image', '[data-pv-image-trigger] img',
    'img.pv-matrix__dialog-image', 'img.pv-color-card-zoom__image',
    'product-image-zoom img.pswp__img', 'img.ezoko-product-image', 'img.ezoko-collection-image',
    'img.slideshow__image', 'img.image-with-text__image', 'img.image-overlay__image',
    'img.promotion-block__image', 'img.shop-the-look__image', 'img.shop-the-look__product-image',
    '.shopify-section .rte img', 'img[data-ezoko-protect-image]'
  ].join(',');
  const excluded = '[data-ezoko-image-protection="off"], [contenteditable]:not([contenteditable="false"]), [draggable="true"], input, textarea';

  function deter(event) {
    if (window.Shopify?.designMode) return;
    const image = event.target;
    if (image?.tagName !== 'IMG' || !image.matches(images) || image.closest(excluded)) return;
    // The search app block hosts our own renderer; only its marked product imagery is theme-owned.
    const appBlock = image.closest('.shopify-app-block, [id^="shopify-block-"]');
    if (appBlock && !image.matches('.ezoko-search-shell [data-ezoko-image-wrapper] img')) return;
    event.preventDefault();
  }

  // Delegation handles late Algolia results, section renders and lightbox images without scanning.
  // No propagation blocking, click interception, touch/pointer handling, CSS or keyboard listeners.
  document.addEventListener('contextmenu', deter);
  document.addEventListener('dragstart', deter);
})();
